import React from "react";

export default function HeroBelow() {
  const universities = [
    { name: "Harvard University", logo: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Harvard_University_coat_of_arms.svg" },
    { name: "Oxford University", logo: "https://upload.wikimedia.org/wikipedia/commons/e/e4/Arms_of_University_of_Oxford.svg" },
    { name: "Stanford University", logo: "https://upload.wikimedia.org/wikipedia/commons/b/b5/Seal_of_Leland_Stanford_Junior_University.svg" },
    { name: "MIT", logo: "https://upload.wikimedia.org/wikipedia/en/4/44/MIT_Seal.svg" },
    { name: "University of Toronto", logo: "https://upload.wikimedia.org/wikipedia/en/0/04/Utoronto_coa.svg" },
    { name: "University of Melbourne", logo: "https://upload.wikimedia.org/wikipedia/en/b/b4/The_University_of_Melbourne_Coat_of_Arms.svg" },
    { name: "University of Sydney", logo: "https://upload.wikimedia.org/wikipedia/en/9/9a/University_of_Sydney_coat_of_arms.png" },
    { name: "Columbia University", logo: "https://upload.wikimedia.org/wikipedia/commons/3/33/Coat_of_Arms_of_Columbia_University.svg" },
    { name: "Yale University", logo: "https://upload.wikimedia.org/wikipedia/commons/0/07/Yale_University_Shield_1.svg" },
    { name: "UCLA", logo: "https://upload.wikimedia.org/wikipedia/commons/0/0d/The_University_of_California_UCLA.svg" },
  ];

  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-[#1E3A8A] via-[#2563EB] to-[#1E40AF] py-10 md:py-14">

      <div className="marquee-track-smooth">

        {[...universities, ...universities].map((uni, i) => (
          <div
            key={uni.name + i}
            className="flex items-center gap-5 px-8 py-5 
            bg-white/20 backdrop-blur-2xl 
            border border-white/30 
            rounded-full text-white text-base md:text-lg font-semibold 
            shadow-xl hover:bg-white/30 hover:scale-110 transition-all duration-300 cursor-pointer"
          >
            {/* LOGO */}
            <div className="bg-white rounded-full w-12 h-12 md:w-14 md:h-14 flex items-center justify-center shadow-lg">
              <img
                src={uni.logo}
                alt={`${uni.name} logo`}
                className="max-h-8 md:max-h-9 max-w-9 object-contain"
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>

            {/* NAME */}
            <span className="whitespace-nowrap tracking-wide">
              {uni.name}
            </span>

          </div>
        ))}

      </div>
    </div>
  );
}
